import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import moment from "moment";
import BotConfiguration from "../../../Customization/botConfiguration";
import { AppConfig } from "../../../Utils/app-config";

let temporary = AppConfig.getSessionDataFunction();
interface Props {
  sessionId: string | null;
  sessionObj: string | null;
  botId: string | null;
  expiresDateTime: moment.Moment | string | null;
}

export const getSessionStoreData = (payload: Props): Props => {
  const expiry = moment().add(BotConfiguration.SESSION_EXPIRY_TIMEOUT_DAYS, 'days');
  payload.expiresDateTime = expiry.toISOString();
  return payload;
}

let INITIAL_STATE: Props = {
  sessionId: null,
  sessionObj: null,
  botId: null,

  expiresDateTime: moment()
};
if (temporary) {
  let expiry = moment()
  if (temporary.expiresDateTime) {
    expiry = moment(temporary.expiresDateTime)
  }
  INITIAL_STATE = getSessionStoreData({
    sessionId: temporary.sessionId,
    sessionObj: temporary.sessionObj,
    botId:temporary.sessionObj,
    expiresDateTime: expiry
  });
}



// const INITIAL_STATE: any = {};

const sliceSessionId = createSlice({
  name: "session_slice",
  initialState: INITIAL_STATE,
  reducers: {
    StoreSessionId(state, { payload }: PayloadAction<Props>) {
      // console.log("store fn", payload)
      // const expiry = moment().add(BotConfiguration.SESSION_EXPIRY_TIMEOUT_DAYS, 'days');
      AppConfig.setSessionDataFunction(payload);
      return payload;
    },
    RemoveSessionId() {
      // console.log("remove fn")
      let temp = { sessionId: null, sessionObj: null, botId: null,expiresDateTime: null };
      AppConfig.setSessionDataFunction(temp);
      return temp;
    },
  },
});

export default sliceSessionId.reducer;
export const { StoreSessionId, RemoveSessionId } = sliceSessionId.actions;

export const useSessionIdStore = (state: any) => {
  const returnData = {...state.botData.currentSessionData as Props};
  if (returnData?.expiresDateTime) {
    returnData.expiresDateTime = moment(returnData?.expiresDateTime);
  }
  return returnData;
};
